import React, { Component } from 'react'

class Gallery extends Component {
    constructor(props){
        super(props);
        this.state = {
            expo : [
                {image: '1.jpg', detail: 'Delhi Expo'},
                {image: '2.jpg', detail: 'Delhi Expo'},
                {image: '3.jpg', detail: 'Delhi Expo'},
                {image: '4.jpg', detail: 'Delhi Expo'},
                {image: '5.jpg', detail: 'Delhi Expo'},
                {image: '6.jpg', detail: 'Delhi Expo'},
                {image: '7.jpg', detail: 'Delhi Expo'},
                {image: '8.jpg', detail: 'Delhi Expo'},
            
               
            ],
            fabrication:[
                {image: '1.jpg', detail: 'For LabSetup'},
                {image: '2.jpg', detail: 'For LabSetup'},
                {image: '3.jpg', detail: 'For LabSetup'},
              
                {image: '4.jpg', detail: 'For LabSetup'},
                {image: '5.jpg', detail: 'For LabSetup'},
                {image: '6.jpg', detail: 'For LabSetup'},
                {image: '7.jpg', detail: 'For Field Demonstration'},
                {image: '8.jpg', detail: 'For Field Demonstration'},
                {image: '9.jpg', detail: 'For Field Demonstration'},
                {image: '10.jpg', detail: 'For Field Demonstration'},
                {image: '11.jpg', detail: 'For Field Demonstration'},
                {image: '12.jpg', detail: 'For Field Demonstration'},
                {image: '13.jpg', detail: 'For Field Demonstration'},
                {image: '14.jpg', detail: 'For Field Demonstration'},
               
            ],
            pcb:[
                {image: '1.jpg', detail: 'Driver Layout'},
                {image: '2.jpg', detail: 'Driver 3D'},
                {image: '3.jpg', detail: 'Sensor Layout'},
                {image: '4.jpg', detail: 'Sensor 3D'},
                {image: '5.jpg', detail: 'Power Board Layout'},
                {image: '6.jpg', detail: 'Power Board 3D'},
                {image: '7.jpg', detail: 'Trip Layout'},
                {image: '8.jpg', detail: 'Trip 3D'},
               
            ],
            field:[
                {image: '1.jpg', detail: 'Realization'},
                {image: '2.jpg', detail: 'Realization'},
                {image: '3.jpg', detail: 'Realization'},
                {image: '4.jpg', detail: 'Realization'},
                {image: '5.jpg', detail: 'Realization'},
                {image: '6.jpg', detail: 'Realization'},
           
               
            ],
        }
    }
      
    render(){
        let expoimg =  this.state.expo.map(e => {
            return(
                <div className="w3-quarter  w3-container w3-margin-bottom">
                        <div className="w3-card-2 w3-white w3-round-large w3-center my-gallery-card" >
                           
                            <img src={"./images/gallery/expo/"+e.image} alt={e.detail} class="my-stage" />
                            
                            <div className="w3-container w3-row w3-padding">  
                                    <div className=""><b>{e.detail}</b></div>
                            </div>            
                        </div>  
                </div> 
            )
        })
        let fabricationimg =  this.state.fabrication.map(e => {
            return(
                <div className="w3-quarter  w3-container w3-margin-bottom">
                        <div className="w3-card-2 w3-white w3-round-large w3-center my-gallery-card" >
                           
                            <img src={"./images/gallery/fabrication/"+e.image} alt={e.detail} class="my-stage" />
                            
                            <div className="w3-container w3-row w3-padding">  
                                    <div className=""><b>{e.detail}</b></div>
                            </div>            
                        </div>  
                </div> 
            )
        })
        let pcbimg =  this.state.pcb.map(e => {
            return(
                <div className="w3-quarter  w3-container w3-margin-bottom">
                        <div className="w3-card-2 w3-white w3-round-large w3-center my-gallery-card" >
                           
                            <img src={"./images/gallery/pcb/"+e.image} alt={e.detail} class="my-stage" />
                            
                            <div className="w3-container w3-row w3-padding">  
                                    <div className=""><b>{e.detail}</b></div>
                            </div>            
                        </div>  
                </div> 
            )
        })
        let fieldimg =  this.state.field.map(e => {
            return(
                <div className="w3-quarter  w3-container w3-margin-bottom">
                        <div className="w3-card-2 w3-white w3-round-large w3-center my-gallery-card" >
                           
                            <img src={"./images/gallery/field/"+e.image} alt={e.detail} class="my-stage" />
                            
                            <div className="w3-container w3-row w3-padding">  
                                    <div className=""><b>{e.detail}</b></div>
                            </div>            
                        </div>  
                </div> 
            )
        })
        



        return(
            <div className='w3-container w3-center'>
                 <h4><b>Image Gallery</b></h4>
                 <h6 className='w3-card-2 w3-white w3-round-large w3-center my-gallery-card w3-padding w3-margin-bottom w3-border-bottom w3-border-blue'><b>Fabrication</b></h6>
                <div className='w3-row '>
              
                          {fabricationimg}     
                </div> 
                 
                <h6 className='w3-card-2 w3-white w3-round-large w3-center my-gallery-card w3-padding w3-margin-bottom w3-border-bottom w3-border-blue'><b>PCB Designs</b></h6>
                <div className='w3-row '>
              
                          {pcbimg}     
                </div> 
                <h6 className='w3-card-2 w3-white w3-round-large w3-center my-gallery-card w3-padding w3-margin-bottom w3-border-bottom w3-border-blue'><b>6th Smart Cities India Expo Visit</b></h6>
                <div className='w3-row '>
              
                          {expoimg}     
                </div> 
                <h6 className='w3-card-2 w3-white w3-round-large w3-center my-gallery-card w3-padding w3-margin-bottom w3-border-bottom w3-border-blue'><b>Field Realization</b></h6>
                <div className='w3-row '>
              
                          {fieldimg}     
                </div> 


                <h4><b>Video Gallery</b></h4>


                <div className='w3-row '>
                    <div className="w3-quarter  w3-container w3-margin-bottom">
                        <div className="w3-card-2 w3-white w3-round-large w3-center my-gallery-card" >
                           
                            <img src="./images/dei_model.png" alt='UiT Norway' class="my-stage" />
                            
                            <div className="w3-container w3-row w3-padding">  
                                    <div className="w3-large"><b>UiT The Arctic University of Norway, Norway</b></div>
                            </div>            
                        </div>  
                    </div>   
                    <div className="w3-quarter  w3-container w3-margin-bottom">
                        <div className="w3-card-2 w3-white w3-round-large w3-center my-gallery-card" >
                           
                            <img src="./images/dei_model.png" alt='UiT Norway' class="my-stage" />
                           
                            <div className="w3-container w3-row w3-padding">
                                    <div className="w3-large"><b>UiT The Arctic University of Norway, Norway</b></div>
                            </div>            
                        </div>  
                    </div>     
                    <div className="w3-quarter  w3-container w3-margin-bottom">
                        <div className="w3-card-2 w3-white w3-round-large w3-center my-gallery-card" >
                           
                            <img src="./images/dei_model.png" alt='UiT Norway' class="my-stage" />
                            
                            <div className="w3-container w3-row w3-padding"> 
                                    <div className="w3-large"><b>UiT The Arctic University of Norway, Norway</b></div>
                            </div>            
                        </div>     
                    </div> 
                    <div className="w3-quarter  w3-container w3-margin-bottom">
                        <div className="w3-card-2 w3-white w3-round-large w3-center my-gallery-card" >
                           
                            <img src="./images/dei_model.png" alt='UiT Norway' class="my-stage" />
                           
                            <div className="w3-container w3-row w3-padding"> 
                                    <div className="w3-large"><b>UiT The Arctic University of Norway, Norway</b></div>
                            </div>            
                        </div>     
                    </div>           
                </div> 
            </div>
        )
    }
}

export default Gallery